import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import BvInlineNumberEdit from '../number';

export default class BvInlineHeatmapEdit extends BvInlineNumberEdit {
  originalValue = this.args.value;

  @tracked error = '';

  get style() {
    return this.args.style ?? 'percent';
  }

  get unit() {
    return this.args.unit ?? 'month';
  }

  get hasChanged() {
    return this.originalValue !== this.args.value;
  }

  @action
  resetValue() {
    this.intermediateValue = this.parseValue(this.args.value);
  }

  @action
  onChange(value: number) {
    this.error =
      value < 0 && this.style === 'percent'
        ? this.intl.t('errors.positive', { description: this.intl.t('numberStyle.percent') })
        : '';

    this.intermediateValue = this.parseValue(value);
  }
}
